import { CardProps } from './card.component';

interface ViewProps<T> {
    onClick: () => void;
}

export const useCard = <T extends { id: string }>(props: CardProps<T>): ViewProps<T> => {
    const handleClick = props.onClick;

    return {
        onClick: handleClick
    };
};
